import React from 'react'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'
import moment from 'moment'

const formatDate = (date) => moment(date).format('DD.MM.YYYY')

const StyledContractCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  padding: 21px 19px 30px 19px;
  background-color: #fff;
  border-radius: 4px;

  margin-bottom: 20px;

  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #b0bac9;

  .title {
    letter-spacing: 1.12px;
    text-transform: uppercase;
  }
`

const ContractInfo = styled.div`
  margin-top: 26px;

  font-size: 14px;
  .name {
    color: #2e384d;
    font-weight: 600;
  }

  .date {
    color: #8798ad;
  }
`

const ContractCard = ({ name, start_date, end_date, t }) => {
  return (
    <StyledContractCard>
      <div className="title">{t('contracts:activeContracts')}</div>
      <ContractInfo>
        <div className="name">{name}</div>
        <div className="date">
          {formatDate(start_date)} to {formatDate(end_date)}
        </div>
      </ContractInfo>
    </StyledContractCard>
  )
}

export default withNamespaces()(ContractCard)
